// removed by extract-text-webpack-plugin
module.exports = {"block":"DmcaPage_block_31ydM","content":"DmcaPage_content_2t_Ir"};